import contract from '@mailobj-browser/front/js/contracts/contract.js'
import message from './message/message.js'
import alert from './alert/alert.js'

export default contract({
  alert,
  message,
})